package app.nestbridge.feature.careteam.usecase

import app.nestbridge.feature.careteam.model.CareTeam
import app.nestbridge.feature.careteam.service.CareTeamService
import me.tatarka.inject.annotations.Inject

@Inject
class FindCareTeamsByChildIdUseCase(
    private val careTeamService: CareTeamService,
) {
    suspend operator fun invoke(childId: String): List<CareTeam> =
        careTeamService.findByChildId(childId)
}
